import { type PropsWithChildren } from 'react';
import Sidebar from './Sidebar';
import Topbar from './Topbar';
import SideBarCreateWebinar from './SideBarCreateWebinar';
import MobileSideBarCreateWebinar from './MobileSideBarCreateWebinar';
import UsageExpiredAlert from '@/components/billing/UsageExpiredAlert';
import { useAppSelector } from '@/app/hooks';
import type { RootState } from '@/app/store';
import UnpaidModal from '../billing/UnpaidModal';
import SuspendModal from '../billing/SuspendModal';
import ConversionRecommendationModal from '../common/ConversionRecommendationModal';
import IntercomMessenger from '@/components/support/IntercomMessenger';

export default function AppShell({
  children,
  createWebinar = false,
}: Readonly<PropsWithChildren<{ createWebinar?: boolean }>>) {
  const usage = useAppSelector((s: RootState) => s.billing.usage.data);
  const isCustomPlan = usage?.planName === 'Custom';

  return (
    <>
      <IntercomMessenger />
      {!isCustomPlan && (
        <>
          <UsageExpiredAlert />
          <UnpaidModal />
          <SuspendModal />
        </>
      )}
      {!createWebinar && <ConversionRecommendationModal />}
      {createWebinar ? (
        <div className="min-h-svh bg-white flex flex-col lg:flex-row">
          <aside className="hidden lg:block">
            <SideBarCreateWebinar />
          </aside>
          <div className="flex-1 flex flex-col">
            <header className="sticky top-0 w-full z-10 bg-white lg:hidden">
              <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-8 ">
                <MobileSideBarCreateWebinar />
              </div>
            </header>
            <main className="flex-1">{children}</main>
          </div>
        </div>
      ) : (
        <div className="min-h-svh grid grid-cols-1 lg:grid-cols-[260px_1fr] bg-white">
          <aside className="hidden lg:block">
            <Sidebar />
          </aside>

          <div className="flex min-h-svh min-w-0 flex-col">
            <Topbar />
            <main className="flex-1 min-w-0 px-4 py-6 md:px-8">{children}</main>
          </div>
        </div>
      )}
    </>
  );
}
